import React from 'react';

function MediaItemCard() {
  return (
    <div style={styles.card}>
      <h2 style={styles.title}>Spirited Away</h2>
      <p style={styles.details}>Type: Anime Movie</p>
      <p style={styles.details}>Duration: 2h 5min</p>
      <p style={styles.details}>Status: Watched</p>
    </div>
  );
}

const styles = {
  card: {
    border: '1px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '16px',
    maxWidth: '400px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  title: {
    marginBottom: '8px',
  },
  details: {
    margin: '4px 0',
  },
};

export default MediaItemCard;